// TODO: Fix the linting issues
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */

export const getParamsForEventHook = (hook: string, params: unknown) => {
  try {
    if (hook == "io_in_stateUpdate") {
      return (params as any)[0].sessionState;
    }
    if (hook == "io_in_runUpdate") {
      return (params as any)[0];
    }

    if (hook == "io_in_skillUsed") {
      return (params as any)[0];
    }
    if (hook == "runComplete") {
      return params;
    }

    if (hook == "io_in_addUserMessage") {
      return (params as any)[0].message.content;
    }
  } catch (_e) {
    console.error("Error Parsing Params for EventHook: " + hook, params);
  }
  return params;
};